import classNames from "classnames";
import React, { FC, memo, useCallback } from "react";

import { ITestable, testAttr } from "@/browser";

import { IBlurable, IChangeable, ICheckable, IInputBasicProps } from "../types";

export interface IRadioProps
  extends IChangeable,
    IBlurable,
    Pick<ICheckable, "checked">,
    Partial<IInputBasicProps>,
    ITestable {}

export const Radio: FC<IRadioProps> = memo(props => {
  const { checked, children, className, invalid, onChange, readonly, testName, touched, value, ...rest } = props;

  const onChangeHandler = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const currentValue = event.target.value;
      if (onChange) {
        onChange(currentValue);
      }
    },
    [onChange],
  );

  const elementClasses = classNames("el-form-radio", className, {});
  const inputClasses = classNames("el-form-radio__input", { checked });
  const shapeClasses = classNames("el-form-radio__shape", className, {
    checked,
    "el-form-radio__shape--not-valid": invalid,
  });

  return (
    <span {...testAttr({ testName: `${testName}` })} className={elementClasses}>
      <input
        {...rest}
        type="radio"
        className={inputClasses}
        checked={checked}
        value={value}
        onChange={onChangeHandler}
        {...testAttr({ testName: `${testName}` }, { sufix: "radio" })}
      />
      <span className={shapeClasses} />
    </span>
  );
});
